// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2P8pe"};